export class Constant {

  public static dateFormat = "medium";
  public static source = "Admin";
  public static RESPONSE_SUCCESS = "AST-200";
  public static RESPONSE_FAILURE = "AST-102";
  pdfBytes: Uint8Array;
  public static LOGIN_ATTEMPt = 3;
  public static PAGE = 0;
  public static SIZE = 10;
  public static DEFAULT_SIZE = 1;
  public static Asc = 'asc';
  public static Dsc = 'desc';
  public static enterPriseKey = 'c-id';
  public static X_XSRF_TOKEN = "cxi";
  public static CART_COUNT = "ccc";
  public static Sup = "VST";
  public static REF = "VRT";
  public static SU = "KST";
  public static checkoutTimerCount = 360;
  public static USER_FAILURE = "AST-103";
  public static RESPONSE_SUCCESS_VERIFY = "AST-201";
  public static DEFAULT_PAGE_SIZE = 1;
  public static XSRF_TOKEN = "cci";
  public static DEVICE_TYPE = "MOBILE";
  public static DEVICE = "deviceType";
  public static REFERER = "ecomdev.calsoftgroup.com";
  public static ENTERPRISE_SITE = "c-ref";
  public static siteName = 'fast'
  public static about = 'AboutUs';
  public static terms = 'terms';
  public static privacy = 'privacy';
  public static shortAbout = 'shortAbout';
  public static OTP_TIMER = 60;
  public static CART_ID = "ast";
  public static GUEST_LOGIN: any = "glIn";
  public static USER_INACTIVE_FAILURE = "AST-105";
  public static payment_policy = 'paymentPolicy';
  public static REFERAL_ID: any = "ref";
  public static REFERRED_PRODUCT_ID = "refp";
  public static BANNER_HEIGHT = "bH";
  public static BANNER_WIDTH = "bW";
  public static BANNER_HEIGHT_MOBILE = "bHM";
  public static BANNER_WIDTH_MOBILE = "bWM";
  public static BANNER_HEIGHT_TABLET = "bHT";
  public static BANNER_WIDTH_TABLET = "bWT";
  public static B2B_USER = "gxi";
  public static GOOGLE_ANALYTICS_ENABLED = "gae";
  public static CONVERSION_TRACKING = "cfs";
  public static TN_ID = "es_n";
  static TN: any;
  public static Source_Header = "sc";
  static ORDER_TRACKING_NEW_STATUS = "New";
  static ORDER_ON_PROCESS = "Work On Progress";
  static DISAPPROVED_ON_PROCESS = "Disapproved";
  public static Doc = "DOC";
  public static BACK_GROUD_COLOR = '#0b27c2';
  public static BIL = "BIL";
  public static LEAD_POPUP = "lp";
  public static COUNTRY_LOCATION = "CL";
  public static USER_DETAILS = "UD";
  public static MOBILE_Device = "0";
  public static DEVICE_MODEL = "1";
  public static LEAD_SOURCE = "Flowzo-Web";
  public static authProactiveRefreshWindowMs = 3 * 60 * 1000;
  public static authClockSkewMs = 60 * 1000;
  public static authRefreshTimeoutMs = 10_000;
}

